import { css } from 'styled-components';

type Color = string | ((props: { theme: any }) => string);

type Options = {
  /** The X's own colour, which the square is a tint of. */
  tone?: Color;
  /** The X as the mouse is on it. */
  strong?: Color;
  /** What the tint is mixed into; `transparent` where the X sits on something other than the page's background. */
  over?: Color;
  amount?: number;
  spread?: number;
};

/**
 * A popup's X as the mouse reaches it (Petr, 2026-11-03): a soft square of the X's own colour behind it and the X a touch
 * stronger. The square reaches past the X with a shadow, so it takes no room and the X stays where it is.
 */
export const softCloseHover = ({
  tone = ({ theme }) => theme.textColor,
  strong = ({ theme }) => theme.textStrongColor,
  over = ({ theme }) => theme.background,
  amount = 14,
  spread = 2
}: Options = {}) => css`
  && {
    border-radius: 5px;
    transition: background-color 0.12s ease, border-color 0.12s ease, box-shadow 0.12s ease, color 0.12s ease,
      opacity 0.12s ease;
    i {
      transition: color 0.12s ease;
    }
  }
  &&:hover {
    background-color: color-mix(in srgb, ${tone} ${amount}%, ${over});
    border-color: transparent;
    box-shadow: 0 0 0 ${spread}px color-mix(in srgb, ${tone} ${amount}%, ${over});
    color: ${strong};
    i {
      color: ${strong};
    }
  }
`;
